import axios from 'axios';
import {EVENT} from '../../url_constants';

export default {
  createCalendar(data = {}) {
    return axios({
        method: 'POST',
        url: EVENT,
        data
    });
  },
}